import React from "react"

import Layout from "../components/Layout"
import SEO from "../components/seo"

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    {/* <div>
      <p>Or contact us by phone or email</p>
      <a
        href="mailto:info@controlgap.com"
        style={{ marginRight: "20px" }}
      >
        info@controlgap.com
      </a>
      <a href="tel:1-866-644-8808" >
        1-866-644-8808
      </a>
    </div> */}
    <div id="category-info" className="category-info">
      <div className="container">
        <i className="control-gap">r</i>
        <h1>Page not found</h1>
        <h3>
          We couldn't find a page at this address, please check again or select
          one of the links below.
        </h3>
        <i
          className="control-gap"
          style={{ fontSize: "40px", color: "lightgrey" }}
        >
          s
        </i>
      </div>
    </div>
  </Layout>
)

export default NotFoundPage
